import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCloseIcon = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("mask", {
			id: "mask0_40_4281",
			style: { maskType: "alpha" },
			maskUnits: "userSpaceOnUse",
			x: 0,
			y: 0,
			width: 24,
			height: 24,
			children: /* @__PURE__ */ _jsx("rect", {
				width: 24,
				height: 24,
				fill: "#D9D9D9"
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			mask: "url(#mask0_40_4281)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M12 13.3998L7.1 18.2998C6.91667 18.4831 6.68334 18.5748 6.4 18.5748C6.11667 18.5748 5.88334 18.4831 5.7 18.2998C5.51667 18.1165 5.425 17.8831 5.425 17.5998C5.425 17.3165 5.51667 17.0831 5.7 16.8998L10.6 11.9998L5.7 7.0998C5.51667 6.91647 5.425 6.68314 5.425 6.3998C5.425 6.11647 5.51667 5.88314 5.7 5.6998C5.88334 5.51647 6.11667 5.4248 6.4 5.4248C6.68334 5.4248 6.91667 5.51647 7.1 5.6998L12 10.5998L16.9 5.6998C17.0833 5.51647 17.3167 5.4248 17.6 5.4248C17.8833 5.4248 18.1167 5.51647 18.3 5.6998C18.4833 5.88314 18.575 6.11647 18.575 6.3998C18.575 6.68314 18.4833 6.91647 18.3 7.0998L13.4 11.9998L18.3 16.8998C18.4833 17.0831 18.575 17.3165 18.575 17.5998C18.575 17.8831 18.4833 18.1165 18.3 18.2998C18.1167 18.4831 17.8833 18.5748 17.6 18.5748C17.3167 18.5748 17.0833 18.4831 16.9 18.2998L12 13.3998Z",
				fill: "white"
			})
		})
	]
});
const ForwardRef = forwardRef(SvgCloseIcon);
export default ForwardRef;
